import {default as types} from '../constants'
import {default as DataService} from '../services/data'
import {default as redirect} from '../utils/redirect'
import {default as Config} from '../config'

//import { pushState } from 'redux-router'

export function redirectCustomerData(token) {
	return (dispatch) => {
		dispatch(loginUserSuccess(token, localStorage.getItem('userName')));
		redirect(dispatch, 'customer/order');
	};
}

export function redirectToLogin(){
	return (dispatch, state) => {
		let states = state();

		if(states.routing.locationBeforeTransitions.pathname.indexOf('register/confirm') === -1)
			redirect(dispatch, 'login');
	};
}

export function loginUserSuccess(token, userName) {
	localStorage.setItem('token', token);
	localStorage.setItem('userName', userName);
	return {
		type: types.LOGIN_USER_SUCCESS,
		payload: {
			token: token,
			userName: userName
		}
	};
}

export function loginUserFailure(error) {
	localStorage.removeItem('token');
	localStorage.removeItem('userName');
	return {
		type: types.LOGIN_USER_FAILURE,
		payload: {
			status: error.response.status,
			statusText: error.response.statusText
		}
	};
}

export function loginUserRequest() {
	return {
		type: types.LOGIN_USER_REQUEST
	};
}

export function logout() {
	localStorage.removeItem('token');
	localStorage.removeItem('userName');
	return {
		type: types.LOGOUT_USER
	};
}

export function logoutAndRedirect() {
	return (dispatch, state) => {
		dispatch(logout());
		redirect(dispatch, 'login');
	};
}

export function loginUser(form) {
	return function(dispatch) {
		return DataService.request(Config.apiUrl+'user/login', { method: 'POST'}, form.model, dispatch)
		.then(form.checkResponse)
		.then(form.props.onSuccess)
		//.then(form.afterSend)
		.then(form.setErrorsOnInputs)
		.then(function(response){
			dispatch(loginUserSuccess(response.token, response.userName));
			redirect(dispatch, 'customer/order');
		});
	};
}



/** WEBPACK FOOTER **
 ** ./js/actions/auth.js
 **/